/*@ngInject*/
const NotificationController = function ($scope, $state, $q, localization, coreConstant, coreMediator, currentUserModel, currentSubmissionModel, notificationModel, notificationType, preferenceModel) {

    const openingSubmissionFromNotificationMarksNotificationAsReadPreference = preferenceModel.get('system.openingSubmissionFromNotificationMarksNotificationAsRead');
    const openingSubmissionFromNotificationMarksNotificationAsRead = openingSubmissionFromNotificationMarksNotificationAsReadPreference === 'true' || _.isNil(openingSubmissionFromNotificationMarksNotificationAsReadPreference);

    localization.setupLocale('notification', require('./notification.i18n.json'));

    this.isOpen = false;
    this.notificationModel = notificationModel;
    this.limit = coreConstant.notifications.loadLimit;
    this.limitIncrement = coreConstant.notifications.loadLimit;
    this.userId = currentUserModel.getCurrentUser().userId;
    this.disableLoadMore = false;
    this.numberOfUnacknowledged = 0;
    this.numberOfUnread = 0;
    this.tooltip = i18n.t('notification|notification.tooltip');
    this.markAsReadTooltip = i18n.t('notification|notification.popout.markAsRead');
    this.markAsUnreadTooltip = i18n.t('notification|notification.popout.markAsUnread');
    this.controlsVisible = {};
    this.notificationTooltips = {};
    this.unreadLabel = i18n.t('notification|notification.popout.unread');
    this.isLoading = false;
    this.isLoadingMore = false;

    this.init = function () {
        const isLoadingMore = false;

        if (!notificationModel.areNotificationsPopulated()) {
            this.getNotifications(isLoadingMore);
        }
        this.getCounts();
    };

    this.onIconClick = function () {
        this.isOpen = !this.isOpen;
        if (!this.isOpen) {
            this.numberOfUnacknowledged = 0;
            this.disableLoadMore = false;
            coreMediator.acknowledgeByUserId(this.userId, notificationType.REGULAR);
        } else {
            this.controlsVisible = {};
            this.notificationTooltips = {};

            if (this.limit >= notificationModel.getNotifications().length) {
                this.disableLoadMore = true;
            }
        }
    };

    this.onLoadMoreClick = function () {
        const isLoadingMore = true;

        if (!this.disableLoadMore) {
            this.limit += this.limitIncrement;
            this.getNotifications(isLoadingMore);
        }
    };

    this.onInsuredNameClick = function (notification) {
        let promise;

        if (notification.read) {
            promise = $q.when();
        } else {
            if (openingSubmissionFromNotificationMarksNotificationAsRead) {
                promise = coreMediator.markAsReadByNotificationId(notification.id, true);
            } else {
                promise = $q.when();
            }
        }

        promise.then(() => {
            let params = {submissionId: notification.submissionId},
                stateName = 'submission.form';

            this.onIconClick();

            if (_.isNil(currentSubmissionModel.getCurrentSubmission()) || currentSubmissionModel.getSelectedSubmission().id !== notification.submissionId) {
                $state.go(stateName, params);
            }
        });
    };

    this.getNotificationMessage = function (notification) {
        const actorName = notification.actorName === 'AUTHENTICATION_SERVER' ? 'System' : notification.actorName;
        return `<strong>${actorName}</strong> ${notification.message}`;
    };

    this.getNotifications = function (isLoadingMore) {
        if (isLoadingMore) {
            this.isLoadingMore = true;
        } else {
            this.isLoading = true;
        }

        coreMediator.resetUserNotificationRegistrations(notificationType.REGULAR).finally(() => {
            const latest = false;
            const unreadOnly = this.isFilterSelected(coreConstant.notifications.filters.UNREAD);

            coreMediator.findByNotifiedUserId(this.userId, notificationType.REGULAR, 0, this.limit + this.limitIncrement, latest, unreadOnly).then((notifications) => {
                if (this.limit >= notifications.length) {
                    this.disableLoadMore = true;
                }
                notificationModel.setNotifications(notifications);
            }).finally(() => {
                this.isLoading = false;
                this.isLoadingMore = false;
            });
        });
    };

    this.getCounts = function () {
        const latest = false;

        coreMediator.countUnacknowledgedByUserId(this.userId, notificationType.REGULAR, latest).then((numberOfUnacknowledged) => {
            this.numberOfUnacknowledged = numberOfUnacknowledged;
        });

        coreMediator.countUnreadByUserId(this.userId, notificationType.REGULAR, latest).then((numberOfUnread) => {
            this.numberOfUnread = numberOfUnread;
        });
    };

    this.isFilterSelected = function (filter) {
        return notificationModel.getSelectedFilter() === filter;
    };

    this.selectFilter = function (filter) {
        const isLoadingMore = false;

        if (notificationModel.getSelectedFilter() !== filter) {
            notificationModel.setSelectedFilter(filter);

            this.limit = coreConstant.notifications.loadLimit;
            this.disableLoadMore = false;
            this.getNotifications(isLoadingMore);
        }
    };

    this.areAllNotificationsRead = function () {
        return this.numberOfUnread === 0;
    };

    this.markAllAsRead = function () {
        if (!this.areAllNotificationsRead()) {
            // set local notifications as read
            this.numberOfUnread = 0;
            _.each(notificationModel.getNotifications(), (notification) => {
              notification.read = true;
            });
            // call backend
            coreMediator.markAllAsReadByUserId(this.userId, notificationType.REGULAR).then(() => {
                coreMediator.acknowledgeByUserId(this.userId, notificationType.REGULAR);
            });
        }
    };

    this.showControls = function (notification) {
        this.controlsVisible[notification.id] = true;
    };

    this.hideControls = function (notification) {
        this.controlsVisible[notification.id] = false;
    };

    this.areControlsVisible = function (notification) {
        return this.controlsVisible[notification.id];
    };

    this.getMarkAsReadTooltip = function (notification) {
        let tooltip;

        if (notification.read) {
            tooltip = this.markAsUnreadTooltip;
        } else {
            tooltip = this.markAsReadTooltip;
        }

        return tooltip;
    };

    this.toggleRead = function (notification) {
        const hideControls = this.isFilterSelected(coreConstant.notifications.filters.UNREAD);

        coreMediator.markAsReadByNotificationId(notification.id, notification.read).then(() => {
            if (!notification.acknowledged) {
                coreMediator.acknowledgeByNotificationId(notification.id);
            }

            if (hideControls) {
                this.hideControls(notification);
            }
        });
    };

    this.getUnreadNotificationsCount = function () {
        return `${this.numberOfUnread} ${this.unreadLabel}`;
    };

    this.shouldShowUnreadNotificationsCount = function () {
        return this.numberOfUnread > 0;
    };

    this.shouldDisableLoadMore = function () {
        return this.disableLoadMore || this.isLoading || this.isLoadingMore;
    };

    $scope.$on(coreConstant.event.CREATE_NOTIFICATION, (event, notification) => {
        if (notificationType.REGULAR === notification.type) {
            if ((this.isFilterSelected(coreConstant.notifications.filters.UNREAD) && !notification.read) || this.isFilterSelected(coreConstant.notifications.filters.ALL)) {
                notificationModel.prependNotification(notification);
                if (notificationModel.getNotifications().length > this.limit) {
                    this.disableLoadMore = false;
                }
                this.getCounts();
            }
        }
    });

    $scope.$on(coreConstant.event.UPDATE_NOTIFICATION, (event, notifications) => {
        let getCounts = false;

        _.each(notifications, (notification) => {
            const isLoadingMore = false;

            if (notificationType.REGULAR === notification.type) {
                if (this.isFilterSelected(coreConstant.notifications.filters.UNREAD) && notification.read) {
                    notificationModel.removeNotification(notification);

                    if (notificationModel.getNotifications().length === 0) {
                        this.getNotifications(isLoadingMore);
                    } else if (this.limit >= notificationModel.getNotifications().length) {
                        this.disableLoadMore = true;
                    }
                } else {
                    notificationModel.updateNotification(notification);
                }

                getCounts = true;
            }
        });

        if (getCounts) {
            this.getCounts();
        }
    });

    $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function () {
        notificationModel.clearNotifications();
        currentUserModel.clearRegistrations();
        currentUserModel.clearNotificationRegistrations();
    });

    this.init();
};

angular.module('umCore')
    .controller('notificationController', NotificationController);
